import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { PORTAL_ORIGIN } from '../../lib/siteUrls';
import './Header.css';

const NAV_LINKS = [
  { label: 'Home',       to: '/' },
  { label: 'Leadership', to: '/about' },
  { label: 'Chapters',   to: '/chapters' },
  { label: 'Programs',   to: '/programs' },
  { label: 'Tools',      to: '/tools' },
  { label: 'Statistics', to: '/statistics' },
  { label: 'News',       to: '/news' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  // Close menu on route change or Escape key
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  // Prevent body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="site-header">
      <nav className={`site-nav ${menuOpen ? 'is-open' : ''}`}>
        <Link to="/" className="site-nav__logo" onClick={closeMenu}>
          <img src="/images/generalimg/1.svg" alt="Project Level the Field" />
        </Link>

        <ul className="site-nav__menu">
          {NAV_LINKS.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  isActive ? 'site-nav__link is-active' : 'site-nav__link'
                }
                onClick={closeMenu}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
          <li className="site-nav__cta-mobile">
            <Link to="/contact" className="site-nav__contact" onClick={closeMenu}>
              Contact
            </Link>
            <a href={PORTAL_ORIGIN} className="site-nav__cta" onClick={closeMenu}>
              Open portal
            </a>
          </li>
        </ul>

        <div className="site-nav__actions">
          <Link to="/contact" className="site-nav__contact site-nav__contact--desktop">
            Contact
          </Link>
          <a href={PORTAL_ORIGIN} className="site-nav__cta site-nav__cta--desktop">
            Open portal
          </a>
          <button
            className={`site-nav__hamburger ${menuOpen ? 'is-open' : ''}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile backdrop */}
      {menuOpen && <div className="site-nav__backdrop" onClick={closeMenu} />}
    </header>
  );
};

export default Header;
